// Pure helpers for ColourFamiliesPage and its sub-components

export const generateShadeHex = (baseHex, index, total) => {
  const r = parseInt(baseHex.slice(1, 3), 16);
  const g = parseInt(baseHex.slice(3, 5), 16);
  const b = parseInt(baseHex.slice(5, 7), 16);
  const factor = 0.4 + (index / total) * 0.6;
  const lighten = index < total / 2 ? 1 + (1 - index / (total / 2)) * 0.4 : 1;
  const nr = Math.min(255, Math.round(r * factor * lighten));
  const ng = Math.min(255, Math.round(g * factor * lighten));
  const nb = Math.min(255, Math.round(b * factor * lighten));
  return `#${nr.toString(16).padStart(2, "0")}${ng.toString(16).padStart(2, "0")}${nb.toString(16).padStart(2, "0")}`;
};

export const qualities = [
  { id: "600-lining", name: "600 Lining", panna: "small", meters_per_bundle: 20 },
  { id: "600-gold", name: "600 Gold", panna: "small", meters_per_bundle: 20 },
  { id: "060-lining", name: "060 Lining", panna: "small", meters_per_bundle: 20 },
  { id: "006-lining", name: "006 Lining", panna: "small", meters_per_bundle: 20 },
  { id: "6000-shrinkless", name: "6000 Shrinkless", panna: "big", meters_per_bundle: 24 },
  { id: "super-queen", name: "Super Queen", panna: "big", meters_per_bundle: 24 },
  { id: "303-pure-cotton", name: "303 Pure Cotton", panna: "small", meters_per_bundle: 20 },
  { id: "3000-pure-cotton", name: "3000 Pure Cotton", panna: "big", meters_per_bundle: 24 },
  { id: "american-crepe", name: "American Crepe", panna: "big", meters_per_bundle: 24 },
];

export const calcCartTotals = (cart) => {
  const totalMeters = cart.reduce((s, c) => s + c.quantity_meters, 0);
  const totalBundles = cart.reduce(
    (s, c) => s + Math.ceil(c.quantity_meters / c.meters_per_bundle),
    0
  );
  const totalParcels = Math.ceil(totalBundles / 5);
  const transportCharges = totalParcels * 150;
  return { totalMeters, totalBundles, totalParcels, transportCharges };
};

export const isLightHex = (hex) =>
  parseInt(hex.slice(1, 3), 16) +
    parseInt(hex.slice(3, 5), 16) +
    parseInt(hex.slice(5, 7), 16) >
  500;
